import React from 'react'
import Groups from '../../../views/corp/groups/GroupsWrapper'

const groupsRoutes = [
  {
    path: '/corp/groups',
    element: <Groups />
  },
]

export default groupsRoutes